import React from 'react';
import { useSelector } from 'react-redux';
import DashDialog from 'screens/components/basic/DialogHeaderDashboard'

const SupportResource = () =>{
    const { applicationSettings } = useSelector(state => state.common || {});
    const { isHighTide } = applicationSettings || {};

    return(
        <div id="chart12" className={`customerCareBg sm-item ${isHighTide ? `mt-0` : ``}`}>
            <DashDialog text="Support Resources" nolink />
            <div className='position-relative pb-5'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6 border-right'>
                            <div>
                                <h5 className='grayText text-left pl-5'><a href='https://knowledge.techpos.ca/en/knowledge/techpos-system-overview' className='supportResouceLinks' target="_blank">TechPOS System Overview</a></h5>
                                <h5 className='grayText text-left pl-5'><a href='https://knowledge.techpos.ca/en/knowledge/getting-started' className='supportResouceLinks' target="_blank">Hardware Setup</a></h5>
                                <h5 className='grayText text-left pl-5'><a href='https://knowledge.techpos.ca/en/knowledge/point-of-sale' className='supportResouceLinks' target="_blank">Sales Process Flow</a></h5>
                                <h5 className='grayText text-left pl-5'><a href='https://techpos.ca/integrations/' className='supportResouceLinks' target="_blank">Integrations</a></h5>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6'>
                            <div>
                                <h5 className='grayText text-left pl-5'><a href="https://knowledge.techpos.ca/en/knowledge" className='supportResouceLinks' target="_blank">Knowledge Base</a></h5>
                                <h5 className='grayText text-left pl-5'><a href='https://knowledge.techpos.ca/_hcms/mem/login?redirect_url=https://knowledge.techpos.ca/portal' className='supportResouceLinks' target="_blank">Ticket Portal</a></h5>
                                <h5 className='grayText text-left pl-5'><a href="https://knowledge.techpos.ca/en/knowledge/techpos-system-overview" className='supportResouceLinks' target="_blank">Training Videos</a></h5>
                                <h5 className='grayText text-left pl-5'><a href="https://techpos.ca/contact-us/" className='supportResouceLinks' target="_blank">Hot Line</a></h5>
                            </div>
                        </div>
                    </div>
                    <div className='d-flx justify-content-around mt-3'>
                    <div className='solutionsandResourcesBg'>
                        <span>SUPPORT HUB</span>
                    </div>
                    <div className='solutionsandResourcesBg'>
                        <span>1.833.722.3663</span>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SupportResource;